module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-desktop-55d4651384c1cd95ae87f18774bf7f8f.webp";